<template>
  <div class="tab-content">
    <div class="mb-4">
      <h2 class="mb-2">Цвета</h2>
      <div class="mb-3">
        <va-input
          :value="colorsSearch"
          @input="$emit('update:colorsSearch', $event)"
          placeholder="Поиск цветов..."
          clearable
        />
      </div>
      <fieldset>
        <div v-for="color in filteredColors" :key="color.id">
          <va-checkbox
            v-model="formData.colors"
            :label="color.name"
            :value="color.id"
            :array-value="String(color.id)"
          />
        </div>
        <div v-if="filteredColors.length === 0" class="text-muted mt-2">
          Цвета не найдены
        </div>
      </fieldset>
    </div>
    <div class="mb-4">
      <div class="mb-3">
        <h2>Бейджы</h2>
      </div>
      <div>
        <va-checkbox v-model="formData.is_new" label="Новинка" />
      </div>
      <div>
        <va-checkbox v-model="formData.is_discount" label="Скидка" />
      </div>
      <div v-if="mode === 'create'">
        <va-checkbox v-model="formData.is_hidden" label="Скрыть из публичной части сайта" />
      </div>
    </div>
    <div class="mb-4">
      <h2 class="mb-2">Состав</h2>
      <div class="mb-3">
        <va-input
          :value="componentsSearch"
          @input="$emit('update:componentsSearch', $event)"
          placeholder="Поиск состава..."
          clearable
        />
      </div>
      <fieldset>
        <div v-for="component in filteredComponents" :key="component.id">
          <va-checkbox
            v-model="formData.components"
            :label="component.title"
            :value="component.id"
            :array-value="String(component.id)"
          />
        </div>
        <div v-if="filteredComponents.length === 0" class="text-muted mt-2">
          Состав не найден
        </div>
      </fieldset>
    </div>
    <div class="mb-4">
      <h2 class="mb-2">Поводы</h2>
      <div class="mb-3">
        <va-input
          :value="reasonsSearch"
          @input="$emit('update:reasonsSearch', $event)"
          placeholder="Поиск поводов..."
          clearable
        />
      </div>
      <fieldset>
        <div v-for="reason in filteredReasons" :key="reason.id">
          <va-checkbox
            v-model="formData.reasons"
            :label="reason.name"
            :value="reason.id"
            :array-value="String(reason.id)"
          />
        </div>
        <div v-if="filteredReasons.length === 0" class="text-muted mt-2">
          Поводы не найдены
        </div>
      </fieldset>
    </div>
    <div class="mb-4">
      <h2 class="mb-2">Теги</h2>
      <div class="mb-3">
        <va-input
          :value="tagsSearch"
          @input="$emit('update:tagsSearch', $event)"
          placeholder="Поиск тегов..."
          clearable
        />
      </div>
      <fieldset>
        <div v-for="tag in filteredTags" :key="tag.id">
          <va-checkbox
            v-model="formData.tags"
            :label="tag.name"
            :value="tag.id"
            :array-value="String(tag.id)"
          />
        </div>
        <div v-if="filteredTags.length === 0" class="text-muted mt-2">
          Теги не найдены
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductFormTabFilters",
  props: {
    formData: { type: Object, required: true },
    mode: { type: String, default: "create" },
    colorsSearch: { type: String, default: "" },
    componentsSearch: { type: String, default: "" },
    reasonsSearch: { type: String, default: "" },
    tagsSearch: { type: String, default: "" },
    filteredColors: { type: Array, default: () => [] },
    filteredComponents: { type: Array, default: () => [] },
    filteredReasons: { type: Array, default: () => [] },
    filteredTags: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.tab-content {
  grid-column: 1 / -1;
}
fieldset {
  max-height: 300px;
  overflow: auto;
}
</style>
